var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF1D8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-1440-desktop-designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop--1440px-Transactions",
    transform: "translate(-207.000000, -1057.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transaction-table",
    transform: "translate(177.000000, 354.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#21383D",
    x: 0,
    y: 690.195979,
    width: 1198,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2271512,719.167164 C36.3946738,719.167164 36.5533793,719.096629 36.659183,718.964374 L38.792891,716.363366 L42.7869807,717.994507 C42.8575165,718.020958 42.9280523,718.038592 42.9985881,718.038592 C43.0955748,718.038592 43.1925615,718.012141 43.2719143,717.968056 C43.4218029,717.879886 43.5276066,717.738815 43.5540575,717.571292 L45.8112031,704.028418 C45.846471,703.807994 45.7583013,703.596387 45.5731448,703.464132 C45.484975,703.402413 45.3703544,703.367145 45.2557337,703.367145 C45.158747,703.367145 45.0617602,703.393596 44.9735905,703.446498 L30.302144,711.910794 C30.1169875,712.016598 30.0111838,712.219388 30.0200008,712.430996 C30.0376348,712.65142 30.1698894,712.836576 30.3726798,712.915929 L33.855385,714.344279 L43.2807313,706.188577 L35.6628648,715.525754 L35.6628648,718.602878 C35.6628648,718.840936 35.8127534,719.052544 36.0331778,719.131897 C36.0948966,719.158347 36.1654324,719.167164 36.2271512,719.167164 Z",
    id: "\\uF1D8",
    fill: "#fff",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvocation);
export default __webpack_public_path__ + "static/media/invocation.14534dc2.svg";
export { ForwardRef as ReactComponent };